const Roles = {
    admin: 'ADMIN',
    citizen: 'CITIZEN',
    company: 'COMPANY',
}

export default Roles
